import React, { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { l, Modal } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import {
  AiAutomationLayoutActions,
  AiAutomationLayoutSelectors,
} from 'apps/aiAutomation/store/layout'

import { getConfirmCopiesBySource } from './lib/getConfirmCopiesBySource'

export const CloseConfirmationModal = () => {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector(AiAutomationLayoutSelectors.getIsConfirmOpen)
  const shouldShow = useAppSelector(AiAutomationLayoutSelectors.getShowConfirm)
  const source = useAppSelector(AiAutomationLayoutSelectors.getConfirmSource)
  const copies = getConfirmCopiesBySource(source)

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => shouldShow && currentLocation !== nextLocation,
  )

  const onConfirm = () => {
    dispatch(AiAutomationLayoutActions.confirmClosed({ confirm: true }))

    if (blocker.state === 'blocked') {
      blocker.proceed?.()
    }
  }

  const onCancel = () => {
    dispatch(AiAutomationLayoutActions.confirmClosed({ confirm: false }))

    if (blocker.state === 'blocked') {
      blocker.reset?.()
    }
  }

  useEffect(() => {
    if (blocker.state === 'blocked') {
      dispatch(AiAutomationLayoutActions.confirmOpenedByAction())
    }
  }, [blocker.state, dispatch])

  return (
    <Modal
      width={460}
      open={isOpen}
      disableCloseButton
      disableOverlayClose
      disableEscapeClose
      buttons={[
        {
          onClick: onCancel,
          label: l.getString(copies.cancelButton),
        },
        {
          onClick: onConfirm,
          variant: 'danger',
          label: l.getString(copies.confirmButton),
        },
      ]}
      title={l.getString(copies.title)}
    >
      <p className="p-x-xs p-y">{l.getString(copies.description)}</p>
    </Modal>
  )
}
